module.exports = __webpack_public_path__ + "static/media/tickets.31997807.svg";